import { useEffect, useRef } from "react";
import { Player } from "@lordicon/react";
import styles from "./SecondScreen.module.css";

// ייבוא האייקונים
import phoneIcon from "../icons/wired-outline-140-earphone-telephone-hover-calling.json";
import calendarIcon from "../icons/wired-outline-1334-order-history-hover-pinch.json";
import moneyIcon from "../icons/wired-outline-799-credit-card-morph-terminal.json";
import mailIcon from "../icons/wired-outline-202-chat-hover-oscillate.json";
import taskIcon from "../icons/wired-outline-1854-office-desk-hover-pinch.json";
import ScrollTimeline from "../components/Timeline/Timeline";

export default function SecondScreen() {
  const playerRef1 = useRef(null);
  const playerRef2 = useRef(null);
  const playerRef3 = useRef(null);
  const playerRef4 = useRef(null);

  const handleComplete = (ref) => {
    setTimeout(() => {
      ref?.current?.playFromBeginning();
    }, 2500);
  };

  useEffect(() => {
    playerRef1?.current?.playFromBeginning();
    playerRef2?.current?.playFromBeginning();
    playerRef3?.current?.playFromBeginning();
    playerRef4?.current?.playFromBeginning();
  }, []);

  return (
    <section className={styles.section}>
      <div className={styles.bgGradient}></div>
      <div className={styles.gridOverlay}></div>

      <div className={styles.container}>
        <h2 className={styles.title}>עסק בצמיחה צריך ניהול, לא אלתור</h2>
        <p className={styles.description}>
          כשהעסק גדל, העומס גדל איתו.
          <br />
          פתאום אתה עושה הכל לבד.
          <br />
          וניהול אדמיניסטרטיבי שואב זמן, אנרגיה ופוקוס.
        </p>

        <div className={styles.iconsGrid}>
          {/* קוביה 1: שיחות + לידים */}
          <div className={styles.iconItem}>
            <div className={styles.iconWrapper}>
              <div className={styles.icon}>
                <Player
                  icon={phoneIcon}
                  ref={playerRef1}
                  size="100%"
                  onComplete={() => handleComplete(playerRef1)}
                />
              </div>
            </div>
            <h3 className={styles.iconTitle}>שיחות ולידים חמים הולכים לאיבוד</h3>
            <p className={styles.iconText}>
              פניות נכנסות, הודעות, שיחות ולידים חמים.
              אתה רוצה לחזור לכולם, אבל לא תמיד מספיק בזמן.
              לקוח שלא קיבל מענה מהיר מאבד עניין וממשיך הלאה.
            </p>
          </div>

          {/* קוביה 2: יומן */}
          <div className={styles.iconItem}>
            <div className={styles.iconWrapper}>
              <div className={styles.icon}>
                <Player
                  icon={calendarIcon}
                  ref={playerRef2}
                  size="100%"
                  onComplete={() => handleComplete(playerRef2)}
                />
              </div>
            </div>
            <h3 className={styles.iconTitle}>יומן הפגישות מבולגן</h3>
            <p className={styles.iconText}>
              פגישה אחת דוחפת את השנייה.
              תזכורות לא תמיד יוצאות בזמן.
              נוצר בלגן שמוביל לחוסר שליטה ולפספוסים מיותרים.
            </p>
          </div>

          {/* קוביה 3: גבייה */}
          <div className={styles.iconItem}>
            <div className={styles.iconWrapper}>
              <div className={styles.icon}>
                <Player
                  icon={moneyIcon}
                  ref={playerRef3}
                  size="100%"
                  onComplete={() => handleComplete(playerRef3)}
                />
              </div>
            </div>
            <h3 className={styles.iconTitle}>גבייה לא אמורה לנהל אותך</h3>
            <p className={styles.iconText}>
              תשלומים, תזכורות ומעקב אחרי לקוחות.
              במקום להתמקד בצמיחה, אתה רודף אחרי כסף שכבר הרווחת.
              ניהול נכון מחזיר שליטה.
            </p>
          </div>

          {/* קוביה 4: כיבוי שריפות + שחיקה */}
          <div className={styles.iconItem}>
            <div className={styles.iconWrapper}>
              <div className={styles.icon}>
                <Player
                  icon={mailIcon}
                  ref={playerRef4}
                  size="100%"
                  onComplete={() => handleComplete(playerRef4)}
                />
              </div>
            </div>
            <h3 className={styles.iconTitle}>כיבוי שריפות ושחיקה יומיומית</h3>
            <p className={styles.iconText}>
              כל בוקר מתחיל במיילים, הודעות ומשימות קטנות.
              תיאומים, מסמכים, ספקים ודוחות.
              אלו לא מכניסות כסף, אבל שוחקות אותך וגוזלות זמן יקר.
            </p>
          </div>
        </div>

        <h2 className={styles.title}>והזמן פשוט עף</h2>
        <p className={styles.description}>
          אתה רץ כל היום.
          עובד קשה.
          אבל מרגיש שאתה דורך במקום.
        </p>

        <h2 className={styles.titleHighlight}>החדשות הטובות הן שזה לא חייב להיות ככה</h2>
        <p className={styles.description}>
          תחשוב איך ייראה היום שלך בעוד כמה חודשים.
        </p>

        <ScrollTimeline />
      </div>
    </section>
  );
}
